import { getSubmit } from "@ui-seeker/utils"

import { BACKEND_APIS, BANNERS_ROUTES } from "@constants"
import { useAppToast } from "@ui-seeker/app";


export default function useBannersDetailsViewScreenshot() {
    const { showToast } = useAppToast()

    const handleClick = (searchID) => {
        showToast.info("Searching...")
        getSubmit(`${BACKEND_APIS.BANNERS}/screenshot/${searchID}`).then(({ url, isHtmlContent, message }) => {
            if (!message) {
                showToast.success("Screenshot search successfully")
                !!isHtmlContent
                    ? window.open(
                        BANNERS_ROUTES.VIEW_SCREENSHOT_URL
                            .replace(':type', 'v2/sov')
                            .replace(':idSearch', searchID),
                        '_blank'
                    )
                    : window.open(url, '')
            } else {
                showToast.warning(message)
            }
        })
    }

    return {
        handleClick
    }
}